import React from 'react';
import Navbar from '../../../components/Navbar';
import Header from './Header';
import Section from './Section';

const DetailKum = () => (
  <>
    <Navbar />
    <Header />
    <Section />
  </>
);

export default DetailKum;
